import clsx from "clsx";
import { FC, PropsWithChildren } from "react";

export type BadgeBackground =
  | "marigold"
  | "primary"
  | "neutral"
  | "cadet"
  | "purple"
  | "rose_red";

const softBackgrounds: Record<BadgeBackground, string> = {
  marigold: "bg-marigold-50",
  primary: "bg-primary-50",
  neutral: "bg-neutral-25",
  cadet: "bg-cadet-25",
  purple: "bg-purple-25",
  rose_red: "bg-rose-25",
};

const Badge: FC<
  PropsWithChildren<{
    background: BadgeBackground | null | undefined;
    className?: string;
    size?: "sm" | "md";
  }>
> = ({ children, background, className, size = "md" }) => {
  return (
    <div
      className={clsx(
        "min-w-[40px] rounded-full w-fit py-2xs px-3xs text-center flex-none text-body-2",
        background && softBackgrounds[background],
        className,
        {
          "py-2xs px-3xs": size === "md",
          "py-xs px-2xs": size === "sm",
        }
      )}
    >
      {children}
    </div>
  );
};
export default Badge;
